export const getFields = (sideDimensions) => {
    const fields = {
        rectangle: [
            {
                label: 'Width',
                name: 'width',
                value: sideDimensions?.width,
            },
            {
                label: 'Height',
                name: 'height',
                value: sideDimensions?.height,
            },
        ],
        square: [
            {
                label: 'Width',
                name: 'width',
                value: sideDimensions?.width,
            },
            {
                label: 'Height',
                name: 'height',
                value: sideDimensions?.height,
            },
        ],
        LShape: [
            {
                label: 'Width',
                name: 'width',
                value: sideDimensions?.width,
            },
            {
                label: 'Height',
                name: 'height',
                value: sideDimensions?.height,
            },
        ],
        circle: [
            {
                label: 'Radius',
                name: 'radius',
                value: sideDimensions?.radius,
            }
        ],
        triangle: [
            {
                label: 'Base',
                name: 'base',
                value: sideDimensions?.base,
            },
            {
                label: 'Height',
                name: 'height',
                value: sideDimensions?.height,
            },
        ]
    }

    return fields
}